<template>
  <section class="section">
    <div class="container">
      <SectionHead eyebrow="PAIN POINTS">
        传统模式的<span style="color:#ff7883">四把枷锁</span>
      </SectionHead>
      <p class="section-copy pain-copy">
        不是你不努力，是模式本身有问题。这四把枷锁，锁住的不只是利润，更是你做大的可能性。
      </p>
      <div class="grid-2">
        <PainCard
          v-for="(lock, i) in locks"
          :key="i"
          :title="lock[0]"
          :description="lock[1]"
          :icon="icons[i]"
          :tone="i + 1"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import SectionHead from '@/components/display/SectionHead.vue';
import PainCard from '@/components/cards/PainCard.vue';

const LOCK_ICONS = [
  '<svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  '<svg viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
  '<svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
  '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="6"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg>'
];

export default {
  name: 'HomePainPoints',
  components: { SectionHead, PainCard },
  data() {
    return { icons: LOCK_ICONS };
  },
  computed: {
    ...mapState('ecosystem', ['locks'])
  }
};
</script>

<style lang="less" scoped>
.pain-copy {
  text-align: center;
  max-width: 700px;
  margin: -30px auto 40px;
}
</style>
